import { createStore } from "@tanstack/store"
import { registerSessionCleanup } from "@/shared/lib/auth"

interface ActiveBoardState {
	userId: number | undefined
}

const activeBoardStore = createStore<ActiveBoardState>({
	userId: undefined,
})

export const setActiveBoard = (userId: number | undefined): void => {
	activeBoardStore.setState(() => ({ userId }))
}

export const isActiveBoardUser = (userId: number): boolean => {
	return activeBoardStore.state.userId === userId
}

registerSessionCleanup(() => setActiveBoard(undefined))
